import type { SalaryCurrency as SalaryCurrencyType } from '@seek/salary-data';
import { useTranslations } from '@vocab/react';
import { Dropdown } from 'braid-design-system';
import type { ChangeEvent } from 'react';

import { useSalaryCurrencyTaxonomy } from 'src/app/shared/taxonomies/useSalaryCurrencyTaxonomy';

import translations from './.vocab';

export const SalaryCurrency = ({
  currency,
  handleSalaryCurrencyOnChange,
}: {
  currency: SalaryCurrencyType;
  handleSalaryCurrencyOnChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const { t } = useTranslations(translations);
  const { currencyOptions } = useSalaryCurrencyTaxonomy(
    currency as SalaryCurrencyType,
  );

  return (
    <Dropdown
      id="salary_currency"
      aria-label={t('salary-currency-aria-label')}
      onChange={handleSalaryCurrencyOnChange}
      value={currency}
      placeholder={t('salary-currency-placeholder')}
      label={t('salary-currency-label')}
      reserveMessageSpace
    >
      {currencyOptions.map(({ text, value }) => (
        <option key={value} value={value}>
          {text}
        </option>
      ))}
    </Dropdown>
  );
};
